import React, { useCallback } from 'react';

import { Editable, RenderElementProps, RenderLeafProps } from 'slate-react';

import Element from './EditorTextArea.Element';
import Leaf from './EditorTextArea.Leaf';
import Toolbar from './EditorTextArea.Toolbar';
import styles from './EditorTextArea.less';
import type { EditorTextAreaProps } from './index';

type EditorProps = {
  onBlur: () => void;
  onDOMBeforeInput?: (event: InputEvent) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  onPaste: (event: React.ClipboardEvent) => void;
} & Pick<
  EditorTextAreaProps,
  'spellCheck' | 'toolbar' | 'placeholder' | 'disabled'
>;

const Editor = ({
  disabled,
  onDOMBeforeInput,
  onBlur,
  onKeyDown,
  onPaste,
  placeholder,
  spellCheck,
  toolbar,
}: EditorProps) => {
  const renderElement = useCallback(
    (props: RenderElementProps) => <Element {...props} />,
    [],
  );
  const renderLeaf = useCallback(
    (props: RenderLeafProps) => <Leaf {...props} />,
    [],
  );

  return (
    <>
      {!disabled && <Toolbar toolbar={toolbar} />}
      <Editable
        className={styles.field}
        disabled={disabled}
        onBlur={onBlur}
        onDOMBeforeInput={onDOMBeforeInput}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        placeholder={placeholder}
        renderElement={renderElement}
        renderLeaf={renderLeaf}
        spellCheck={spellCheck}
      />
    </>
  );
};

export default Editor;
